module.exports = {
	"tiles": {
		"usa": {
			"url": "https://livemap-tiles{s}.waze.com/tiles/{z}/{x}/{y}.png{retina}",
			"subdomains": "1234"
		},
		"world": {
			"url": "https://worldtiles{s}.waze.com/tiles/{z}/{x}/{y}.png{retina}",
			"subdomains": "1234"
		},
		"israel": {
			"url": "https://il-livemap-tiles{s}.waze.com/tiles/{z}/{x}/{y}.png{retina}",
			"subdomains": "1234"
		}
	}
};